export const DEFAULT = 'DEFAULT';
export const CUSTOM = 'CUSTOM';

export const PM_GRAPH_OPTIONS_TYPE = {
    SS_PROGRESS: 'SS_PROGRESS',
};

export const MESSAGE = {
    ZOOM: 'Click and drag the cursor to zoom in.',
    GOAL: ' Custom Goal Set displays if it is different from Benchmark Goal.',
};
